import { Button, Card } from "antd";
import { getLogger } from "loglevel";
import React, { Component, ErrorInfo, ReactNode, useContext } from "react";
import { withRouter } from "react-router";
import { Layout } from "../components";
import { Profile } from "../models/profile-interface";
import { AuthContext } from "../utilites/auth";
import { Logger } from "../utilites/loglySetup";
import BgAnimationCanvas from "./login/BackgroundAnimation";

interface Props {
  children: ReactNode;
  profile: Profile;
}

interface State {
  hasError: boolean;
  error?: any;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  private promiseRejectionHandler = (event: PromiseRejectionEvent) => {
    this.setState({
        error: event.reason
    });
  }

  componentDidMount(): void {
    window.addEventListener('unhandledrejection', this.promiseRejectionHandler)
  }

  componentWillUnmount(): void {
    window.removeEventListener('unhandledrejection', this.promiseRejectionHandler);
  }

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    getLogger('Root').error("Uncaught error:", error, errorInfo);
  }

  public render() {
    const { history } = this.props;
    
    history.listen((location, action) => {
      if (this.state.hasError) {
        this.setState({
          hasError: false,
        });
      }
    });

    if (this.state.hasError) {
      if (this?.props?.profile === undefined) {
        return (
          <>
            <BgAnimationCanvas id="BgAnimationCanvas" />
              <Card
                  id="loginCard"
                  style={{top: '50%', width: 600}}
              >
                <h1>An error has occured loading this page. Please try again or
                  <Button
                    id="EmailFeedbackButton"
                    type="link"
                    href="mailto:support@govenda.com"
                    onClick={() => window.open('mailto:support@govenda.com')}
                    style={{marginBottom: 10, marginLeft: 4, padding: 0, fontSize: '1em'}}
                  >
                    contact support
                  </Button>.
                </h1>
              </Card>
          </>
        )
      }

      return (
        <Layout>
          <h1>An error has occured loading this page. Please try again or
            <Button
              id="EmailFeedbackButton"
              type="link"
              href="mailto:support@govenda.com"
              onClick={() => window.open('mailto:support@govenda.com')}
              style={{marginBottom: 10, marginLeft: 4, padding: 0}}
            >
              contact support
            </Button>.
          </h1>
        </Layout>
      );
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);